

const HouseBuildingIcon = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" enable-background="new 0 0 24 24" height="100%" viewBox="0 0 24 24" width="100%" fill="white">
            <g>
                <rect fill="none" height="24" width="24" />
            </g>
            <g>
                <g>
                    <path d="M1,11v10h6v-5h2v5h6V11L8,6L1,11z M13,19h-2v-5H5v5H3v-6.97l5-3.57l5,3.57V19z"
                        rect height="2" width="2" x="17" y="7" />
                    <rect height="2" width="2" x="17" y="11" />
                    <rect height="2" width="2" x="17" y="15" />
                    <polygon points="10,3 10,4.97 12,6.4 12,5 21,5 21,19 17,19 17,21 23,21 23,3" />
                </g>
            </g>
        </svg>
    )
}

const BedroomIcon = () => {
    return (
        <svg width='100%' height='100%' viewBox="0 0 29 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M8.43502 12.9768C10.4353 12.9768 12.05 11.6392 12.05 9.98213C12.05 8.32509 10.4353 6.98749 8.43502 6.98749C6.43472 6.98749 4.82002 8.32509 4.82002 9.98213C4.82002 11.6392 6.43472 12.9768 8.43502 12.9768ZM22.895 6.98749H13.255V13.975H3.61502V4.99106H1.20502V19.9643H3.61502V16.9696H25.305V19.9643H27.715V10.9803C27.715 8.77429 25.5581 6.98749 22.895 6.98749Z" fill="white" />
        </svg>
    )
}

const BathroomIcon = () => {
    return (
        <svg width='100%' height='100%' viewBox="0 0 30 25" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M24.984 13.7611V5.60565C24.984 4.04843 23.4537 2.7807 21.5739 2.7807C20.6701 2.7807 19.8025 3.08016 19.1639 3.60922L17.6576 4.85699C17.4648 4.80708 17.26 4.77713 17.0431 4.77713C16.5611 4.77713 16.1152 4.89692 15.7417 5.09656L19.0675 7.85163C19.3085 7.54218 19.4531 7.17284 19.4531 6.77356C19.4531 6.59388 19.4169 6.43417 19.3687 6.26447L20.875 5.0167C21.0557 4.86697 21.3088 4.77713 21.5739 4.77713C22.1282 4.77713 22.574 5.14647 22.574 5.60565V13.7611H14.3198C13.9583 13.5514 13.6329 13.3119 13.3317 13.0423L11.6447 11.4951C11.4157 11.2855 11.1265 11.1158 10.8132 10.996C10.4397 10.8463 10.03 10.7664 9.60821 10.7664C8.11401 10.7764 6.90901 11.7746 6.90901 13.0124V13.7611H3.29401V19.7503C3.29401 20.8484 4.37851 21.7468 5.70401 21.7468C5.70401 22.2958 6.24626 22.745 6.90901 22.745H23.779C24.4418 22.745 24.984 22.2958 24.984 21.7468C26.3095 21.7468 27.394 20.8484 27.394 19.7503V13.7611H24.984Z" fill="white" />
            <path d="M9.31906 9.76819C10.6501 9.76819 11.7291 8.87436 11.7291 7.77176C11.7291 6.66916 10.6501 5.77533 9.31906 5.77533C7.98805 5.77533 6.90906 6.66916 6.90906 7.77176C6.90906 8.87436 7.98805 9.76819 9.31906 9.76819Z" fill="white" />
        </svg>
    )
}

const AreaIcon = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" height="100%" viewBox="0 0 24 24" width="100%" fill="white">
            <path d="M0 0h24v24H0V0z" fill="none" />
            <path d="M17 15h2V7c0-1.1-.9-2-2-2H9v2h8v8zM7 17V1H5v4H1v2h4v10c0 1.1.9 2 2 2h10v4h2v-4h4v-2H7z" />
        </svg>
    )
}

const CurrencyIcon = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" height="100%" viewBox="0 0 24 24" width="100%" fill="white">
            <path d="M0 0h24v24H0V0z" fill="none" />
            <path d="M11.8 10.9c-2.27-.59-3-1.2-3-2.15 0-1.09 1.01-1.85 2.7-1.85 1.78 0 2.44.85 2.5 2.1h2.21c-.07-1.72-1.12-3.3-3.21-3.81V3h-3v2.16c-1.94.42-3.5 1.68-3.5 3.61 0 2.31 1.91 3.46 4.7 4.13 2.5.6 3 1.48 3 2.41 0 .69-.49 1.79-2.7 1.79-2.06 0-2.87-.92-2.98-2.1h-2.2c.12 2.19 1.76 3.42 3.68 3.83V21h3v-2.15c1.95-.37 3.5-1.5 3.5-3.55 0-2.84-2.43-3.81-4.7-4.4z" />
        </svg>
    )
}

const PetsIcon = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" height="100%" viewBox="0 0 24 24" width="100%" fill="white">
            <path d="M0 0h24v24H0V0z" fill="none" />
            <circle cx="4.5" cy="9.5" r="2.5" />
            <circle cx="9" cy="5.5" r="2.5" />
            <circle cx="15" cy="5.5" r="2.5" />
            <circle cx="19.5" cy="9.5" r="2.5" />
            <path d="M17.34 14.86c-.87-1.02-1.6-1.89-2.48-2.91-.46-.54-1.05-1.08-1.75-1.32-.11-.04-.22-.07-.33-.09-.25-.04-.52-.04-.78-.04s-.53 0-.79.05c-.11.02-.22.05-.33.09-.7.24-1.28.78-1.75 1.32-.87 1.02-1.6 1.89-2.48 2.91-1.31 1.31-2.92 2.76-2.62 4.79.29 1.02 1.02 2.03 2.33 2.32.73.15 3.06-.44 5.54-.44h.18c2.48 0 4.81.58 5.54.44 1.31-.29 2.04-1.31 2.33-2.32.31-2.04-1.3-3.49-2.61-4.8z" />
        </svg>
    )
}

export { HouseBuildingIcon, BedroomIcon, BathroomIcon, AreaIcon, CurrencyIcon, PetsIcon }